<mat-card>
  <mat-card-content>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <h2>Change Password</h2>
       <!-- <mat-error *ngIf="message">
        {{message}}
      </mat-error> -->
      <mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="Token" formControlName="token" required>
      </mat-form-field> 
      <mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="LoginUserStatus" formControlName="loginUserStatus">
      </mat-form-field>
      <mat-form-field [style.display]="'none'" class="full-width-input">
        <input matInput placeholder="User Name" formControlName="userId" required>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput type="password" placeholder="Old Password" formControlName="password" required>
        <mat-error>
          Please provide Old password
        </mat-error>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput type="password" placeholder="New Password" formControlName="newPassword" required>
        <mat-error>
          Please provide valid New password
        </mat-error>
        <mat-hint>Min 8, Max 50 char</mat-hint>
      </mat-form-field>
      <mat-form-field class="full-width-input">
        <input matInput type="password" placeholder="Confirm New Password" formControlName="confirmNewPassword" required>
        <mat-error>
          Please Confirm New password
        </mat-error>
        <mat-hint>Min 8, Max 50 char</mat-hint>
      </mat-form-field>
      <button mat-raised-button color="primary">Submit</button>
    </form>
  </mat-card-content>
</mat-card>